import { Injectable } from '@angular/core'
import { Subject, map } from 'rxjs'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class MiddleService {
  private notify = new Subject<boolean>()
  notifyObservable$ = this.notify.asObservable()

  constructor(private http: HttpClient) {}
  changeBool(data: boolean) {
    if (data !== null) {
      this.notify.next(data)
    }
  }
  GetAlertHistory(b: any) {
    return this.http.post<any>(`/api/Blotter/getAlertHistory`, b)
  }
  GetBlotterHistory(b: number) {
    const param = { blotId: b }
    return this.http.post<any>(`/api/Blotter/getstatusHistory`, param).pipe(
      map((user) => {
        return user
      }),
    )
  }
}
